import React from "react";
import BalanceLayout from "../../layouts/BalanceLayout";

export default function Balance() {
    return (
        <div className="w-full h-full">
            <BalanceLayout />
        </div>
    );
}
